export class PediatricChartTypeModel {
    pediatricChartTypeId: number;
    typeName: string;
    active: boolean;
}